import React, { useEffect, useState } from 'react';
import { apiClient } from '../../config';

const AddModule = () => {
  const [selectedCourse, setSelectedCourse] = useState('');
  const [moduleName, setModuleName] = useState('');
  const [moduleDesc, setModuleDesc] = useState('');
  const [modules, setModules] = useState([]);
  const [courses, setCourses] = useState([]);

  // Loading states
  const [loadingCourses, setLoadingCourses] = useState(false);
  const [loadingModules, setLoadingModules] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  // Fetch all courses on mount
  useEffect(() => {
    fetchCourses();
  }, []);

  // Fetch modules when a course is selected
  useEffect(() => {
    if (selectedCourse) {
      fetchModules(selectedCourse);
    } else {
      setModules([]); // Clear modules when no course is selected
    }
  }, [selectedCourse]);

  const fetchCourses = async () => {
    setLoadingCourses(true);
    try {
      const res = await apiClient.get('/api/course/courses');
      const data = res.data;
      console.log('Courses fetched:', data);
      setCourses(Array.isArray(data) ? data : data.data || []);
    } catch (err) {
      console.error('Error fetching courses:', err);
    } finally {
      setLoadingCourses(false);
    }
  };

  const fetchModules = async (courseId) => {
    setLoadingModules(true);
    try {
      const res = await apiClient.get(`/api/course/modules/${courseId}`);
      setModules(res.data || []);
    } catch (err) {
      console.error('Error fetching modules:', err);
    } finally {
      setLoadingModules(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedCourse || !moduleName || !moduleDesc) {
      alert('Please fill out all fields');
      return;
    }

    const newModule = {
      courseId: selectedCourse,
      name: moduleName,
      description: moduleDesc,
      order: modules.length + 1,
    };

    setSubmitting(true);

    try {
      const response = await apiClient.post('/api/course/modules', newModule);
      console.log('API Response:', response.data);

      await fetchModules(selectedCourse);
      setModuleName('');
      setModuleDesc('');
      alert('Module added successfully!');
    } catch (error) {
      console.error('Error adding module:', error);
      alert(error.response?.data?.message || 'Failed to add module. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>

        {/* Form Section */}
        <div className="row mb-4">
          <div className="col-12">
            <div className="card border-0 shadow-sm">
              <div className="card-header bg-transparent border-bottom py-3">
                <h5 className="mb-0 fw-semibold">Create Module</h5>
              </div>
              <div className="card-body">
                <form onSubmit={handleSubmit} className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">Select Course *</label>
                    <select
                      className="form-select"
                      value={selectedCourse}
                      onChange={(e) => setSelectedCourse(e.target.value)}
                    >
                      <option value="">-- Select Course --</option>
                      {loadingCourses ? (
                        <option>Loading courses...</option>
                      ) : (
                        courses.map((course) => (
                          <option key={course._id} value={course._id}>
                            {course.title}
                          </option>
                        ))
                      )}
                    </select>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fw-semibold">Module Name *</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Module Name"
                      value={moduleName}
                      onChange={(e) => setModuleName(e.target.value)}
                    />
                  </div>

                  <div className="col-12">
                    <label className="form-label fw-semibold">Module Description *</label>
                    <textarea
                      className="form-control"
                      placeholder="Enter Module Description"
                      rows={3}
                      value={moduleDesc}
                      onChange={(e) => setModuleDesc(e.target.value)}
                    />
                  </div>

                  <div className="col-12">
                    <button type="submit" className="btn btn-primary w-100" disabled={submitting}>
                      {submitting ? 'Creating...' : 'Create Module'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Table Section */}
        <div className="row">
          <div className="col-12">
            <div className="card border-0 shadow-sm">
              <div className="card-header bg-transparent border-bottom py-3">
                <h5 className="mb-0 fw-semibold">Module Details</h5>
              </div>
              <div className="card-body p-0 table-responsive">
                <table className="table table-hover table-striped align-middle mb-0">
                  <thead>
                    <tr>
                      <th className="ps-4" style={{ width: "80px" }}>Order</th>
                      <th>Name</th>
                      <th className="pe-4">Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loadingModules ? (
                      <tr>
                        <td colSpan="3" className="text-center py-4 text-muted">Loading modules...</td>
                      </tr>
                    ) : modules.length > 0 ? (
                      modules.map((mod, i) => (
                        <tr key={mod._id || i}>
                          <td className="ps-4 fw-semibold">{mod.order}</td>
                          <td className="fw-semibold">{mod.name}</td>
                          <td className="pe-4">{mod.description}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3" className="text-center py-4 text-muted">No modules added yet.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

      </div>
  );
};

export default AddModule;
